import { store } from "@AppState/redux-store"


let soundEnabled = store.getState().appSettings.appSettings.soundEnabled

store.subscribe(() => {
  soundEnabled = store.getState().appSettings.appSettings.soundEnabled
})

function playSound(sound: HTMLAudioElement | Phaser.Sound.BaseSound){
  try{
    if(soundEnabled){
      sound.play()
    }
  } catch(e) {
    console.log(`Could not play sound ${e}`)
  }
}

export const SoundController = {
  playSound
}
